"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});
var e = require("react/jsx-runtime"),
  o = require("react");
function t(e) {
  return e && "object" == typeof e && "default" in e ? e : {
    default: e
  };
}
var i = t(o),
  n = function () {
    return (n = Object.assign || function (e) {
      for (var o, t = 1, i = arguments.length; t < i; t++) for (var n in o = arguments[t]) Object.prototype.hasOwnProperty.call(o, n) && (e[n] = o[n]);
      return e;
    }).apply(this, arguments);
  };
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function r(e, o, t) {
  if (t || 2 === arguments.length) for (var i, n = 0, r = o.length; n < r; n++) !i && n in o || (i || (i = Array.prototype.slice.call(o, 0, n)), i[n] = o[n]);
  return e.concat(i || o);
}
function l(o) {
  var t = o.size,
    i = void 0 === t ? 25 : t,
    r = o.strokeColor,
    l = void 0 === r ? "none" : r,
    a = o.storkeWidth,
    c = void 0 === a ? 0 : a,
    s = o.className,
    u = void 0 === s ? "star-svg" : s,
    d = o.style;
  return e.jsx("svg", n({
    fill: "currentColor",
    width: i,
    height: i,
    viewBox: "0 0 24 24",
    className: u,
    style: n({}, d)
  }, {
    children: e.jsx("path", {
      fill: "currentColor",
      stroke: l,
      strokeMiterlimit: "10",
      strokeWidth: c,
      d: "M12,17.27L18.18,21l-1.64-7.03L22,9.24l-7.19-0.61L12,2L9.19,8.63L2,9.24l5.46,4.73L5.82,21L12,17.27z"
    }, void 0)
  }), void 0);
}
var a = function () {
  return "ontouchstart" in window || navigator.maxTouchPoints > 0;
};
function c(e, o) {
  switch (o.type) {
    case "PointerMove":
      return n(n({}, e), {
        hoverValue: o.payload
      });
    case "PointerLeave":
      return {
        defaultValue: e.defaultValue,
        hoverValue: null
      };
    case "MouseClick":
      return n(n({}, e), {
        defaultValue: o.payload
      });
    default:
      return e;
  }
}
exports.Rating = function (t) {
  var s,
    u,
    d = t.onClick,
    v = t.initialValue,
    f = void 0 === v ? 0 : v,
    p = t.ratingValue,
    h = void 0 === p ? 0 : p,
    y = t.iconsCount,
    m = void 0 === y ? 5 : y,
    g = t.size,
    k = void 0 === g ? 40 : g,
    x = t.readonly,
    C = void 0 !== x && x,
    w = t.fillColor,
    b = void 0 === w ? "#ffbc0b" : w,
    j = t.fillColorArray,
    M = void 0 === j ? [] : j,
    L = t.emptyColor,
    V = void 0 === L ? "#cccccc" : L,
    N = t.fullIcon,
    P = void 0 === N ? null : N,
    A = t.emptyIcon,
    R = void 0 === A ? null : A,
    S = t.customIcons,
    z = void 0 === S ? [] : S,
    I = t.rtl,
    O = void 0 !== I && I,
    T = t.allowHalfIcon,
    q = void 0 !== T && T,
    B = t.allowHover,
    E = void 0 === B || B,
    F = t.transition,
    H = void 0 !== F && F,
    W = t.className,
    _ = void 0 === W ? "react-simple-star-rating" : W,
    D = t.style,
    X = t.fullClassName,
    Y = void 0 === X ? "filled-icons" : X,
    G = t.emptyClassName,
    J = void 0 === G ? "empty-icons" : G,
    K = t.fullStyle,
    Q = t.emptyStyle,
    U = t.showTooltip,
    Z = void 0 !== U && U,
    $ = t.tooltipDefaultText,
    ee = void 0 === $ ? "Your Rate" : $,
    oe = t.tooltipArray,
    te = void 0 === oe ? [] : oe,
    ie = t.tooltipClassName,
    ne = void 0 === ie ? "react-simple-star-rating-tooltip" : ie,
    re = t.tooltipStyle,
    le = o.useReducer(c, {
      defaultValue: h,
      hoverValue: null
    }),
    ae = le[0],
    ce = ae.defaultValue,
    se = ae.hoverValue,
    ue = le[1];
  i.default.useEffect(function () {
    return ue({
      type: "MouseClick",
      payload: h
    });
  }, [h]);
  var de = function (e) {
      var o = e.clientX,
        t = e.currentTarget.children[0].getBoundingClientRect(),
        i = t.left,
        n = t.right,
        r = t.width,
        l = function (e, o, t) {
          for (var i = 100 / e, n = t / e, r = 100, l = 0; l < e; l += 1) if (o <= n * l + n / 4) {
            r = 0 === l && o < n / 2 ? 0 : i * l;
            break;
          }
          return r;
        }(he, O ? n - o : o - i, r);
      l > 0 && se !== l && ue({
        type: "PointerMove",
        payload: l
      });
    },
    ve = function () {
      se && (ue({
        type: "MouseClick",
        payload: se
      }), d && d(se));
    },
    fe = o.useMemo(function () {
      return Math.round(f / m * 100);
    }, [f, m]),
    pe = o.useMemo(function () {
      return E && se && se || ce && ce || fe;
    }, [E, se, ce, fe]),
    he = o.useMemo(function () {
      return q ? 2 * m : m;
    }, [q, m]),
    ye = o.useCallback(function (e) {
      var o = 1;
      return e && (o = q ? e / he : e / 2 / 10), Math.round(o - 1);
    }, [q, he]),
    me = o.useCallback(function (e) {
      return q ? e / 2 / 10 : ye(e) + 1;
    }, [q, ye]),
    ge = function (e) {
      return te.length > 0 ? te[ye(e)] : me(e) || 0;
    };
  return e.jsxs("span", n({
    style: {
      display: "inline-block",
      direction: "".concat(O ? "rtl" : "ltr"),
      touchAction: "none"
    }
  }, {
    children: [e.jsxs("span", n({
      className: _,
      style: n({
        position: "relative",
        display: "inline-block",
        overflow: "hidden",
        whiteSpace: "nowrap",
        cursor: C ? "" : "pointer",
        verticalAlign: "middle",
        userSelect: "none"
      }, D),
      onPointerMove: C ? void 0 : de,
      onPointerEnter: C ? void 0 : function (e) {
        a() && de(e);
      },
      onPointerLeave: C ? void 0 : function () {
        a() && ve(), ue({
          type: "PointerLeave"
        });
      },
      onClick: C ? void 0 : ve,
      "aria-hidden": "true"
    }, {
      children: [e.jsx("span", n({
        className: J,
        style: n({
          display: "inline-block",
          color: V
        }, Q)
      }, {
        children: r([], Array(m), !0).map(function (t, i) {
          var n;
          return e.jsx(o.Fragment, {
            children: (null === (n = z[i]) || void 0 === n ? void 0 : n.icon) || R || e.jsx(l, {
              size: k
            }, i)
          }, i);
        })
      }), void 0), e.jsx("span", n({
        className: Y,
        style: n((s = {
          position: "absolute",
          top: 0
        }, s[O ? "right" : "left"] = 0, s.color = E && se && M[ye(se)] || ce && M[ye(ce)] || b, s.overflow = "hidden", s.whiteSpace = "nowrap", s.display = "inline-block", s.transition = H ? "width .2s ease, color .2s ease" : "", s.width = "".concat(pe, "%"), s), K),
        title: "".concat(se && me(se) || me(fe), " out of ").concat(m)
      }, {
        children: r([], Array(m), !0).map(function (t, i) {
          var n;
          return e.jsx(o.Fragment, {
            children: (null === (n = z[i]) || void 0 === n ? void 0 : n.icon) || P || e.jsx(l, {
              size: k
            }, void 0)
          }, i);
        })
      }), void 0)]
    }), void 0), Z && e.jsx("span", n({
      className: ne,
      style: n((u = {
        display: "inline-block",
        padding: "5px 15px",
        backgroundColor: "#333",
        color: "#fff"
      }, u[O ? "marginRight" : "marginLeft"] = 20, u.verticalAlign = "middle", u.borderRadius = 5, u), re)
    }, {
      children: se && ge(se) || ce && ge(ce) || fe && ge(fe) || ee
    }), void 0)]
  }), void 0);
};